// Which extension a woo.io page should message (plan §8.1, CLAUDE.md 6).
//
// This is on the SPA side of the channel, not the shell's — a page cannot ask "which
// extension am I talking to", it has to be told. It lives here because the shell is what
// stamps the answer into the page.
//
// ⚠️ THE ORDER IS THE WHOLE POINT, AND THE LAST ENTRY IS A TRAP. `careero.extensionId` is the
// LEGACY extension's hardcoded id from `Constants.java`. During the parallel-launch phase
// both extensions are installed, so falling back to it does not fail — it succeeds, against
// the wrong extension, silently. A top-level SPA tab is where this bites: it has no injected
// `#woo-extension-id` node, so it reaches the fallback every time.
export const EXTENSION_ID_NODE = 'woo-extension-id'

export interface ExtensionIdSources {
  /** The `#woo-extension-id` node the content script injects into the page. */
  fromDom?: string | undefined
  /** `VITE_EXTENSION_ID`, baked in at build time for the target being built. */
  fromBuild?: string | undefined
  /** `window.careero.extensionId` — the LEGACY id. See above. */
  fromViewModel?: string | undefined
}

export interface ResolvedExtensionId {
  id: string | undefined
  source: 'dom' | 'build' | 'view-model' | 'none'
  /** True when the id came from the legacy fallback, which callers should surface. */
  isLegacyFallback: boolean
}

export function resolveExtensionId(sources: ExtensionIdSources): ResolvedExtensionId {
  if (nonEmpty(sources.fromDom)) return { id: sources.fromDom, source: 'dom', isLegacyFallback: false }
  if (nonEmpty(sources.fromBuild)) return { id: sources.fromBuild, source: 'build', isLegacyFallback: false }
  if (nonEmpty(sources.fromViewModel)) {
    return { id: sources.fromViewModel, source: 'view-model', isLegacyFallback: true }
  }
  return { id: undefined, source: 'none', isLegacyFallback: false }
}

function nonEmpty(value: string | undefined): value is string {
  return typeof value === 'string' && value.trim().length > 0
}
